@if (problemInfo && problemInfo.problem) {
  <main class="container-fluid">
    <div class="row row-eq-height">
      <section class="col-8 position-relative">
        <div class="lesson-content">
          <div class="problem-content sticky-top">
            <p><app-content-viewer [content]="problemInfo.problem.content"></app-content-viewer></p>
            <div id="problemHint" [ngbCollapse]="!hint">
              <div class="card">
                <div class="card-body">
                  <p><app-content-viewer [content]="hint"></app-content-viewer></p>
                </div>
              </div>
            </div>
          </div>
          <div class="problem-passage">
            @if (problemInfo.problem && problemInfo.problem.passage) {
              <app-content-viewer
              [content]="problemInfo.problem.passage.content"></app-content-viewer>
            }
          </div>
        </div>
        <!-- Exercise Footer -->
        <div class="lesson-footer">
          <div class="lesson-goals">
            <div class="row">
              <div class="col-1 text-right">
                <i class="fa fa-bullseye"></i>
              </div>
              <div class="col-4">
                <div class="progress">
                  <div class="progress-bar progress-bar-striped" role="progressbar"
                    style="height: 1.5rem; line-height: 1.5rem" aria-valuenow="20" aria-valuemin="0"
                    [style.width.%]="exercisePercentageCompleted"
                    aria-valuemax="100">{{exercisePercentageCompleted}}%
                  </div>
                </div>
              </div>
              <div class="col-2 text-right">
                <i class="fa fa-stopwatch"></i> {{ currentExerciseTime | time}}
              </div>
              <div class="col-4">
                <div class="progress">
                  <div class="w-50">
                    <div class="progress-bar progress-bar-striped bg-primary progress-bar-fast" role="progressbar"
                      [style.width.%]="fasterWidth"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="50">
                    </div>
                  </div>
                  <div class="w-50">
                    <div class="progress-bar progress-bar-striped bg-danger progress-bar-slow" role="progressbar"
                      [style.width.%]="slowerWidth"
                      aria-valuenow="0"
                      aria-valuemin="0"
                      aria-valuemax="50">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Exercise Sidebar -->
      @if (content) {
        <aside class="col-4">
          <div class="lesson-answers">
            <h4>{{content.answerPrompt}}</h4>
            <app-multi-choice
              [options]="problemInfo.problem.answers"
              [title]="title"
              [correctTitle]="correctTitle"
              [incorrectTitle]="incorrectTitle"
              [discardedOptions]="discardedOptions"
              (optionSelected)="onUserSelection($event)"
              (readyToContinue)="handleReadyToContinue()"
              >
            </app-multi-choice>
            @if (readyToContinue) {
              <button class="btn btn-primary" (click)="handleNext()" ngbTooltip="Next Problem">
                {{ nextProblemButton }}
              </button>
            }
          </div>
          <hr>
            <!-- Smartsavers -->
            @if (exerciseService.currentLesson.smartSaversEnabled == 1) {
              <div class="lesson-smartsavers">
                @if (isStopTimerEnable) {
                  <button class="btn btn-primary btn-sm" (click)="onPauseTimer()" ngbTooltip="Pause timer">
                    Pause
                    <span class="badge badge-pill badge-light">{{ numberStopTimer }}</span>
                  </button>
                }
                @if (isHintEnable) {
                  <button
                    class="btn btn-primary btn-sm"
                    (click)="onGetHint()"
                    aria-controls="problemHint">
                    Hint
                    <span class="badge badge-pill badge-light">{{ numberHints }}</span>
                  </button>
                }
                @if (isCutIncorrectEnable) {
                  <button class="btn btn-primary btn-sm" (click)="onCutIncorrect()">
                    50/50
                    <span class="badge badge-pill badge-light">{{ numberCutIncorrect }}</span>
                  </button>
                }
                <button class="btn btn-primary btn-sm" (click)="onSkip()" ngbTooltip="Skip">
                  Skip
                  <span class="badge badge-pill badge-light">∞</span>
                </button>
              </div>
            }
            <hr>
              <div class="custom-control custom-checkbox review-check">
                <input type="checkbox" class="custom-control-input" id="customCheck1" [(ngModel)]="reviewFlagged">
                <label class="custom-control-label" for="customCheck1">
                  <i class="fa fa-exclamation"></i>
                  {{content.flagText}}
                </label>
              </div>
            </aside>
          }
        </div>
      </main>
    } @else {
      <app-spinner></app-spinner>
    }
    <!--TODO: Is this still needed here?-->
    <!--<app-lesson-help></app-lesson-help>-->
